<template>
  <!--门户界面-->
  <div
    :style="{ 'background-image': 'url(' + bgImg + ')' }"
    class="container-layout"
  >
    <div class="container-top" style="background: rgba(255, 255, 255, 0.3)">
      <el-row type="flex" justify="start">
        <el-col :span="2" />
        <el-col :span="5">
          <el-row type="flex" justify="start" align="middle">
            <el-col :span="10">
              <img
                v-if="logoTheme == 'cts'"
                :src="logoImg"
                alt=""
                class="logo-img"
                @click="routeTo('/home/homepage')"
              />
              <img
                v-if="logoTheme == 'dv'"
                :src="logoDvImg"
                alt=""
                class="logo-img"
                @click="routeTo('/home/homepage')"
              />
            </el-col>
            <!--     <el-col :span="19" :offset="1">
              <span class="col-span">
                <i>
                  <img :src="locationIcon" alt="">
                </i>
                <label>{{ locationName }}</label>
              </span>
            </el-col> -->
          </el-row>
        </el-col>
        <el-col :span="16">
          <ul class="ul-tab">
            <li @click="routeTo('/home/homepage')">
              <span class="tab-span">
                <i>
                  <img :src="homeIcon" alt="" />
                </i>
                <router-link to="">{{ $t("login.home") }}</router-link>
              </span>
            </li>
            <!--            <li @click="routeTo('/home/serviceGuide')">-->
            <!--              <span class="tab-span">-->
            <!--                <router-link to="">{{ $t('home.serviceInformation') }}</router-link>-->
            <!--              </span>-->
            <!--            </li>-->
            <!--            <li @click="routeTo()">-->
            <!--              <span class="tab-span">-->
            <!--                <router-link to="">{{ $t('home.complaintsAndSuggestions') }}</router-link>-->
            <!--              </span>-->
            <!--            </li>-->
            <li @click="routeTo('loginIn')">
              <span class="tab-span">
                <i>
                  <img :src="loginIcon" alt="" />
                </i>
                <router-link to="">{{ $t("home.adminLogin") }}</router-link>
              </span>
            </li>
            <li>
              <span class="tab-span">
                <!--  <lang-select class="right-menu-item hover-effect"/> -->
                {{ $t("home.customerServiceTel") }}
              </span>
            </li>
            <li>
              <span class="tab-span">
                 <lang-select class="right-menu-item hover-effect"/>
              </span>
            </li>
          </ul>
        </el-col>
        <el-col :span="1" />
      </el-row>
    </div>
    <div class="login-container-middle">
      <div class="advertise">  
        <img :src="advertise" />
       
      </div>
      <div
        class="login-context"
        :style="{ 'background-image': 'url(' + loginBgImg + ')' }"
      >
        <div class="loginpage" :class="{ isShow: isdisplay }">
          <!--          <el-row v-if="logoTheme == 'cts'">
              <el-col>
                <div class="login-title" :style="{'background-image':'url('+loginBgLogo+')'}"></div>
              </el-col>
              <el-col>
                <div class="login-title" style="padding-top: 7px" >{{ $t('home.title') }}</div>
              </el-col>
            </el-row>
            <el-row v-if="logoTheme == 'dv'">
              <el-col>
                <div v-if="logoTheme == 'dv'" :style="{'background-image':'url('+loginAgLogo+')'}" style="height: 48px;background-repeat: no-repeat;margin-left: -15px;"></div>
              </el-col>
            </el-row> -->
          <el-row v-if="logoTheme == 'cts'">
            <el-col>
              <div
                v-if="logoTheme == 'cts'"
                :style="{ 'background-image': 'url(' + loginBgLogo + ')' }"
                style="
                  height: 48px;
                  background-repeat: no-repeat;
                  background-size: 100%;
                  margin: 100px 0px 80px 0;
                "
              ></div>
            </el-col>
          </el-row>
          <el-row v-if="logoTheme == 'dv'">
            <el-col>
              <div
                v-if="logoTheme == 'dv'"
                :style="{ 'background-image': 'url(' + loginAgLogo + ')' }"
                style="
                  height: 48px;
                  background-repeat: no-repeat;
                  background-size: 100%;
                  margin: 100px 0px 80px -15px;
                "
              ></div>
            </el-col>
          </el-row>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            autocomplete="on"
            class="loginForm"
          >
            <el-row class="login-row">
              <!--   <el-col :span="2">
                <i>
                  <img class="login-icon" :src="userIcon" alt="">
                </i>
              </el-col> -->
              <el-col :span="7" class="login-input-title-vessel">
                <span class="login-input-title">{{$t('login.username')}}</span>
              </el-col>
              <el-col :span="17">
                <el-form-item prop="username" class="login-register-input">
                  <el-input
                    ref="username"
                    v-model="nameComputed"
                    class="login-input"
                    :placeholder="$t('login.username')"
                    name="username"
                    type="text"
                    @change="userChange"
                  />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="2">
                <i v-if="trueIconVisible">
                  <img class="login-icon" :src="trueIcon" alt="">
                </i>
              </el-col> -->
            </el-row>
            <el-row class="login-row">
              <!-- <el-col :span="5">
                <i>
                  <img class="login-icon" :src="pwdIcon" alt="">
                </i>
              </el-col> -->
              <el-col :span="7" class="login-input-title-vessel">
                <span class="login-input-title">{{$t('login.password')}}</span>
              </el-col>
              <el-col :span="17">
                <el-form-item class="login-register-input" prop="password">
                  <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="loginForm.password"
                    class="login-input"
                    :type="passwordType"
                    :placeholder="$t('login.password')"
                    name="password"
                    tabindex="0"
                    autocomplete="on"
                    @keyup.native="checkCapslock"
                    @blur="capsTooltip = false"
                    @input="pwdChange"
                    @keyup.enter.native="handleLogin"
                    @change="loginchange"
                  />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="2">
                <i v-if="iconVisible">
                  <img class="login-icon" :src="trueIcon" alt="">
                </i>
              </el-col> -->
            </el-row>
            <el-row class="rememberPassword">
              <el-checkbox v-model="checked" @click="checked = !checked">{{
                $t("login.rememberPassword")
              }}</el-checkbox>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top: 40px">
              <el-button
                class="login-btn"
                :class="{
                  'login-btnload': isbtnload,
                  'login-btn-disabled': isdisabled,
                }"
                :loading="loading"
                :disabled="disabled"
                @click.native.prevent="handleLogin"
                >{{ $t("button.signIn") }}</el-button
              >
            </el-row>
            <el-row
              v-if="logoTheme == 'dv'"
              style="
                text-align: center;
                color: #ffffff;
                font-size: 13px;
                margin-top: 10px;
              "
            >
              <span
                @click="toregister"
                style="
                  border-bottom: 1px solid #98a4da;
                  padding: 0px 3px;
                  cursor: pointer;
                "
                >{{ $t("login.register") }}</span
              >
            </el-row>
            <!--           <el-row type="flex" justify="end" style="margin-top:15px;">
              <el-col :span="16" style="text-align:left;color:#FFFFFF;font-size:13px;">
                <router-link  :to="{name:'register'}"><span style="border-bottom:1px solid #98A4DA;padding: 0px 3px;">{{ $t('login.register') }}</span></router-link>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top: 40px;">
              <el-col>
                <el-button class="login-btn" :loading="loading" @click.native.prevent="handleLogin" >{{ $t('button.signIn') }}</el-button>
              </el-col>
            </el-row> -->
          </el-form>
        </div>
        <!-- 注册页面 -->
        <div class="register-page">
          <div class="registerpage" :class="{ isShow: !isdisplay }">
            <Register @register-display="registerdisplay"></Register>
          </div>
          <el-row class="login-container-bottom">
            <el-row type="flex" justify="center">
              <el-col :span="24" style="text-align: center; margin-bottom: 5px">
                <label v-if="logoTheme == 'cts'" class="bottom-label-font"
                  >CopyRight ©{{ $t("home.ctsCr") }}</label
                >
                <label v-if="logoTheme == 'dv'" class="bottom-label-font"
                  >CopyRight ©2022-2021 {{ $t("home.dvCrN") }}</label
                >
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="24" style="text-align: center">
                <label class="bottom-label-font">{{ $t("home.glCr") }}</label>
              </el-col>
            </el-row>
            <el-row v-if="logoTheme == 'dv'" type="flex" justify="center">
              <el-col :span="20" style="text-align: center; display: table">
                <img :src="police"/>
                <a
                  class="bottom-label-font public-security"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011302007008"
                  >{{ $t("home.PublicSecurityRN") }}</a
                >
              </el-col>
            </el-row>
            <el-row v-if="logoTheme == 'dv'" type="flex" justify="center">
              <el-col :span="24" style="text-align: center">
                <label class="bottom-label-font"
                  ><a href="https://beian.miit.gov.cn/#/Integrated/index">
                    {{ $t("home.ICPRN") }}</a
                  ></label
                >
              </el-col>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
    <!--     <div class="container-bottom">
      <el-row type="flex" justify="center">
        <el-col :span="8">
          <el-row type="flex" justify="center">
            <el-col :span="24" style="text-align:center">
              <label v-if="logoTheme == 'cts'" class="bottom-label-font">CopyRight ©{{ $t('home.ctsCr') }}</label>
              <label v-if="logoTheme == 'dv'" class="bottom-label-font">CopyRight ©{{ $t('home.dvCr') }}</label>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-col :span="24" style="text-align:center">
              <label class="bottom-label-font">{{ $t('home.glCr') }}</label>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div> -->

    <div class="change-password-dialog">
      <el-dialog
        title="修改密码"
        width="26%"
        :visible.sync="dialogFormVisible"
        @close="clearvalue('ruleForm')"
      >
        <!--   <div>当前用户：{{userNameCn}} </div> -->
        <div class="warn-prompt">
          <span><img src="../../assets/images/add_imgs/warn.png" /></span>
          <div class="warn-title">密码长时间未变更需要修改密码</div>
        </div>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
        >
          <div prop="oldPwd" class="change-password-item">
            <span class="asterisk">*</span><span>旧密码：</span>
            <el-input
              type="password"
              v-model="ruleForm.oldPwd"
              autocomplete="off"
              class="passwordstyle"
            ></el-input>
          </div>
          <div prop="newPwd" class="change-password-item">
            <span class="asterisk">*</span> <span>新密码：</span>
            <el-input
              type="password"
              v-model="ruleForm.newPwd"
              autocomplete="off"
              class="passwordstyle"
            ></el-input>
          </div>
          <div prop="confiPwd" class="change-password-item">
            <span class="asterisk">*</span><span>确认密码：</span>
            <el-input
              type="password"
              v-model="ruleForm.confiPwd"
              autocomplete="off"
              class="passwordstyle"
            ></el-input>
          </div>
          <div class="prompt">
            提示：密码必须包含大写字母、小写字母、数字或特殊符号,长度必须在8到30之间
          </div>
          <div class="change-password-btns">
            <el-button
              class="btn el-button-search"
              type="primary"
              @click="queren(ruleForm)"
              >确定</el-button
            >
            <el-button class="btn" type="primary" @click="resetForm('ruleForm')"
              >取消</el-button
            >
          </div>
        </el-form>
      </el-dialog>
    </div>

    <GoHmTipPage v-if="showGoHmTipPage" @close="showGoHmTipPage = false"/>   
  </div>
</template>

<script>
import { getLocation } from "@/api/messageApi";
import { validUsername } from "@/utils/validate";
import request from "@/utils/request";
import { setToken } from "@/utils/auth";
import LangSelect from "@/components/LangSelect/LangSelect.vue";
import { modifyPwdSysUser } from "@/api/system";
import Register from "@/components/Register/Register.vue";
import { getUserType } from "@/api/overseas";
import GoHmTipPage from './components/GoHmTipPage.vue'
export default {
  name: "Login",
  components: {
    LangSelect,
    Register,
    GoHmTipPage
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("旧密码不能为空"));
      } else {
        if (this.ruleForm.confiPwd !== "") {
          this.$refs.ruleForm.validateField("confiPwd");
        }
      };
      var validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.confiPwd !== '') {
            this.$refs.ruleForm.validateField('confiPwd');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.newPwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
          bgImg: require('../../assets/images/login_imgs/login-bgimg.png'),
        logoImg: require('../../assets/images/login_imgs/cts-logo.png'),
        logoDvImg: require('../../assets/images/login_imgs/logo-dv.png'),
        locationIcon: require('../../assets/images/home_imgs/locationIcon.png'),
        homeIcon: require('../../assets/images/login_imgs/home-icon.png'),
        loginBgImg: require('../../assets/images/login_imgs/login-bg.png'),
        userIcon: require('../../assets/images/login_imgs/user-icon.png'),
        pwdIcon: require('../../assets/images/login_imgs/pwd-icon.png'),
        trueIcon: require('../../assets/images/login_imgs/true-icon.png'),
        loginBgLogo: require('../../assets/images/login_imgs/loginBgLogo.png'),
        loginAgLogo: require('../../assets/images/login_imgs/login-ag-logo.png'),
        loginIcon: require("../../assets/images/home_imgs/login-icon.png"),
        advertise: require("../../assets/images/login_imgs/advertise.png"),
        locationName: window.returnCitySN?.cname,
        trueIconVisible: false,
        iconVisible: false,
        isActive: true,
        clickbg: true,
        flag: 0,
        checked: true,
        loginForm: {
          username: null,
          appCode: "CTS_WEB",
          isExternal: 1,
          isActive: 1
        },
        loginRules: {

        },
        passwordType: 'password',
        capsTooltip: false,
        loading: false,
        showDialog: false,
        redirect: undefined,
        otherQuery: {},
        logoTheme: 'cts',
        dialogFormVisible: false,
        ruleForm: {
          appCode: 'CTS_WEB',
          oldPwd: '',
          newPwd: '',
          confiPwd: '',
          userName: ''
        },
        rules: {
          oldPwd: [
            { validator: validatePass , trigger: 'blur' }
          ],
          newPwd: [
            { validator: validatePass1, trigger: 'blur' }
          ],
          confiPwd: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        disabled: false,
        isbtnload: false,
        isdisabled: false,
        isdisplay: false,
      }
    };
    var validatePass1 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.confiPwd !== "") {
          this.$refs.ruleForm.validateField("confiPwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      bgImg: require("../../assets/images/login_imgs/login-bgimg.png"),
      logoImg: require("../../assets/images/login_imgs/cts-logo.png"),
      logoDvImg: require("../../assets/images/login_imgs/logo-dv.png"),
      police: require("../../assets/images/add_imgs/police.png"),
      locationIcon: require("../../assets/images/home_imgs/locationIcon.png"),
      homeIcon: require("../../assets/images/login_imgs/home-icon.png"),
      loginBgImg: require("../../assets/images/login_imgs/login-bg.png"),
      userIcon: require("../../assets/images/login_imgs/user-icon.png"),
      pwdIcon: require("../../assets/images/login_imgs/pwd-icon.png"),
      trueIcon: require("../../assets/images/login_imgs/true-icon.png"),
      loginBgLogo: require("../../assets/images/login_imgs/loginBgLogo.png"),
      loginAgLogo: require("../../assets/images/login_imgs/login-ag-logo.png"),
      loginIcon: require("../../assets/images/home_imgs/login-icon.png"),
      advertise: require("../../assets/images/login_imgs/advertise.png"),
      locationName: window.returnCitySN?.cname,
      trueIconVisible: false,
      iconVisible: false,
      isActive: true,
      clickbg: true,
      flag: 0,
      checked: true,
      loginForm: {
        username: null,
        appCode: "CTS_WEB",
        isExternal: 1,
        isActive: 1,
      },
      loginRules: {},
      passwordType: "password",
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      logoTheme: "cts",
      dialogFormVisible: false,
      ruleForm: {
        appCode: "CTS_WEB",
        oldPwd: "",
        newPwd: "",
        confiPwd: "",
        userName: "",
      },
      rules: {
        oldPwd: [{ validator: validatePass, trigger: "blur" }],
        newPwd: [{ validator: validatePass1, trigger: "blur" }],
        confiPwd: [{ validator: validatePass2, trigger: "blur" }],
      },
      disabled: false,
      isbtnload: false,
      isdisabled: false,
      isdisplay: false,
      showGoHmTipPage: true,//默认打开升级的提示
    };
  },
  computed: {
    nameComputed: {
      get: function () {
        return this.loginForm.username;
      },
      set: function (val) {
        this.loginForm.username = val.toUpperCase();
      },
    },
  },
  watch: {
    $route: {
      handler: function (route) {
        const query = route.query;
        if (query) {
          this.redirect = query.redirect;
          this.otherQuery = this.getOtherQuery(query);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    /*     if (this.loginForm.username === '') {
        this.$refs.username.focus()
      } else if (this.loginForm.password === '') {
        this.$refs.password.focus()
      }
      if (this.loginForm.username !== '') {
        this.trueIconVisible = true;
      }
      if (this.loginForm.password !== '') {
        this.iconVisible = true;
      }
      let self= this
      self.flag=this.$route.query.flag */
    if (!this.loginForm.username || !this.loginForm.password) {
      this.disabled = true;
      this.isdisabled = true;
    } else {
      this.disabled = false;
      this.isdisabled = false;
    }

    if (this.loginForm.username === "") {
      this.$refs.username.focus();
    } else if (this.loginForm.password === "") {
      this.$refs.password.focus();
    }
    if (this.loginForm.username !== "") {
      this.trueIconVisible = true;
    }
    if (this.loginForm.password !== "") {
      this.iconVisible = true;
    }
    let self = this;
    self.flag = this.$route.query.flag;

    // if(localStorage.userpassword){
    //   let userpassword=JSON.parse(localStorage.getItem('userpassword'))
    //   this.nameComputed=userpassword.name
    //   if(userpassword){
    //     this.loginForm.password=userpassword.password
    //   }else{
    //     this.checked=false
    //   }
    // }

    // let xxx =  localStorage.getItem('userpassword')
    // if(xxx) {

    // }
    let userpassword = JSON.parse(localStorage.getItem("userpassword"));
    if (userpassword) {
      this.nameComputed = userpassword.name;
      if (userpassword.password) {
        this.loginForm.password = userpassword.password;
        this.disabled = false;
        this.isdisabled = false;
      } else {
        this.checked = false;
      }
      this.pwdChange();
    }

    request.post("/web/sys/resource/loadLanguage").then((response) => {
      if (response && response.success === true) {
        if (response.theme !== undefined) {
          localStorage.setItem("logoTheme", response.theme);
          this.logoTheme = response.theme;
          /* localStorage.setItem('logoTheme', 'dv');
            this.logoTheme = 'dv'; */
        }
      }
    });
  },
  methods: {
    toregister() {
      this.isdisplay = !this.isdisplay;
    },
    checkCapslock(e) {
      const { key } = e;
      this.capsTooltip = key && key.length === 1 && key >= "A" && key <= "Z";
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    getMenu() {
      let self = this;
      self.$store.dispatch("user/getMenu").then((res) => {
        console.log(self.$store.state.user.rightRouters);
      });
    },
    // path: '../query/ShippingDate.vue',
    handleLogin() {
      let self = this;
      self.loading = true;
      this.isbtnload = true;
      // self.loginForm.password = window.btoa(self.loginForm.password)
      self.$store
        .dispatch("user/login", self.loginForm)
        .then((res) => {
          if (res && res.success === true) {
            let userpassword = {
              name: "",
              password: "",
            };
            userpassword.name = this.nameComputed;
            if (this.checked === true) {
              userpassword.password = window.btoa(this.loginForm.password);
              // JSON.stringify(localStorage.setItem('password',obj))
            }
            localStorage.setItem("userpassword", JSON.stringify(userpassword));
            // obj.password=this.loginForm.password
            // let userpassword=JSON.parse(localStorage.getItem('userpassword'))
            // localStorage.setItem('userpassword',JSON.stringify(obj))
            // localStorage.removeItem('userpassword')
            console.log(self.env == "dev");
            // if(self.env == 'dev') {
            //
            // } else {
            self.getMenu();
            // }
            var userTypeParm = {
              sysUserId: res.data.userId,
            };
            console.log(this.$store.state.tagsView.visitedViews);
            if (this.$route.query.flag){
             self.$store.dispatch("tagsView/delAllViewsKeepHp").then();
             getUserType(userTypeParm).then((res) => {
                if (res.records === "2") {
                  var dash = {
                    fullPath: "/dashboard",
                    hash: "",
                    meta: { affix: true, title: "dashboard" },
                    name: "Dashboard",
                    path: "/dashboard",
                    redirectedFrom: "/",
                    title: "dashboard",
                  };
                  this.$store.dispatch("tagsView/addView", dash);
                }
                if (res.records === "13") {
                  var overseasWelcome = {
                    fullPath: "/overseas-agency/overseasWelcome",
                    hash: "",
                    meta: { affix: true, title: "overseasWelcome" },
                    name: "overseasWelcome",
                    path: "/overseas-agency/overseasWelcome",
                  };
                  this.$store.dispatch("tagsView/addView", overseasWelcome);
                 /*  if(!this.$cookies.isKey('languageChange')){ */
                    this.$i18n.locale = 'en'
                    this.$store.dispatch('app/setLanguage', 'en')
                  /* } */
                }
           if (self.flag === 1) {
              self.$router.push({
                name: "ShippingDate",
                query: {
                  searchData: self.searchData,
                },
              });
            } else if (self.flag === "StatusHistory") {
              self.$router.push({
                name: "StatusHistory",
                params: {
                  orderNo: self.$route.params.StatusHistoryParams,
                },
              });
            } else if (self.flag === "bookingAdd") {
               self.$router.push({ path: "/booking/Add" });
            } else if (self.flag === "bookingManage") {
              self.$router.push({
                name: "bookingManage",
              });
            }
              });
            }else{
              getUserType(userTypeParm).then((res) => {
                              if (res.records === "2") {
                                self.$store.dispatch("tagsView/delAllViewsKeepHp").then();
                                self.$router.push({
                                  path: "/dashboard",
                                  query: self.otherQuery,
                                });
                                self.loading = false;
                              }
                              if (res.records === "13") {
                                self.$store.dispatch("tagsView/delAllViewsKeepHp").then();
                                self.$router.push({
                                  path: "/overseas-agency/overseasWelcome",
                                  query: self.otherQuery,
                                });
                                self.loading = false;
                                /*  if(!this.$cookies.isKey('languageChange')){ */
                                  this.$i18n.locale = 'en'
                                  this.$store.dispatch('app/setLanguage', 'en')
                             /*    } */
                              }
                            });
            }
          } else {
            self.loading = false;
            this.isbtnload = false;
            self.loginForm.password = "";
            this.isdisabled = true;
            if (res.errorCode == "500001") {
              self.dialogFormVisible = true;
              self.ruleForm.userName = this.loginForm.username;
            }
            return this.$coreMethods.message("error", res.errorMessages[0]);
          }
        })
        .catch((res) => {
          self.loading = false;
          self.loginForm.password = "";
        });

      // self.$refs.loginForm.validate(valid => {
      //   if (valid) {
      //     self.loading = true
      //     self.$store.dispatch('user/login', self.loginForm)
      //       .then(() => {
      //         self.$router.push({ path: self.redirect || '/', query: self.otherQuery })
      //         self.loading = false
      //       })
      //       .catch(() => {
      //         self.loading = false
      //       })
      //   } else {
      //     console.log('error submit!!')
      //     return false
      //   }
      // })
    },
    getOtherQuery(query) {
      return Object.keys(query).reduce((acc, cur) => {
        if (cur !== "redirect") {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    },
    // 路由跳转
    routeTo(val) {
      this.$router.push(val);
    },
    // 用户名输入框改变事件
    userChange(val) {
      this.trueIconVisible = this.loginForm.username !== "";
      if (this.loginForm.username !== "" && this.loginForm.password !== "") {
        this.disabled = false;
        this.isdisabled = false;
      } else {
        this.disabled = true;
        this.isdisabled = true;
      }
    },
    // 密码输入框改变事件
    pwdChange(val) {
      if (this.loginForm.password !== "") {
        this.iconVisible = true;
      } else {
        this.iconVisible = false;
      }
      this.$forceUpdate();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    queren(data) {
      let self = this;
      modifyPwdSysUser(data)
        .then((res) => {
          if (res.status === 0) {
            self.$coreMethods.message("warning", "密码修改成功");
            this.dialogFormVisible = false;
          } else {
            self.$coreMethods.message(
              "warning",
              "旧密码输入不正确，请重新输入"
            );
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clearvalue(formName) {
      this.$refs[formName].resetFields();
    },
    // 输入框改变 登录
    loginchange() {
      if (this.loginForm.password !== "" && this.loginForm.username !== "") {
        this.disabled = false;
        this.isdisabled = false;
      } else {
        this.disabled = true;
        this.isdisabled = true;
      }
    },
    registerdisplay(data) {
      this.isdisplay = data;
      console.log(data)``;
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from);
    next();
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

// ::v-deep .login-input .el-input__inner {
//   background-color: transparent !important;
//   color: rgba(26, 74, 255, 1) ;
//   border-radius: 20px !important;
//   border: none !important;
//   height: 30px;
//   padding: none !important
// }

.login-title {
  height: 30px;
  background-size: 100% 100%;
}
.login-othertitle {
  height: 30px;
  background-size: 70% 100%;
  background-repeat: no-repeat;
}
// 清除浏览器记住密码后的input的默认样式
::v-deep input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  -webkit-text-fill-color: rgba(26, 74, 255, 1) !important;
  -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
  background-color: transparent;
  background-image: none;
  transition: background-color 50000s ease-in-out 0s;
}
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;

  &.hover-effect {
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
}
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1200px;

  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  // top: 50px;
  top: 15px;
  // right: 0;
  left: 190px;
  z-index: 1002;
  // width: calc(100% - #{$sideBarWidth});
  width: calc(100% - 450px);
  transition: width 0.28s;
}

// .hideSidebar .fixed-header {
//   width: calc(100% - 54px)
// }

.mobile .fixed-header {
  width: 100%;
}
.fixed-header-container {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1001;
  width: 100%;
}
.fixed-footer-container {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 1001;
  width: 100%;
  height: 50px;
  text-align: center;
  background-color: #353535;
  .footer-text {
    display: flex;
    flex-flow: column;
    font-size: 12px;
    color: #ffffff;
    line-height: 16px;
    margin-top: 10px;
  }
}
.prompt {
  color: red;
  margin-top: 10px;
}
.asterisk {
  color: red;
}

.changePasswordTitle {
  text-align: center;
  font-size: 24px;
}
.passwordstylkkkke {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}
</style>
